import * as React from 'react';
import { useAuthWithFallback } from '@/contexts/auth-context';
import { hasPermission } from '@/lib/admin-fallback';

export function useToolsCapabilities() {
  const { user, loading } = useAuthWithFallback();

  return {
    loading,
    user,
    hasPermission: (slug: string) => hasPermission(user, slug),
    hasAnyPermission: (slugs: string[]) => slugs.some((slug) => hasPermission(user, slug)),
    canUseTools: hasPermission(user, 'tools.access'),
    canUseImmix: hasPermission(user, 'immix.query'),
    canUseZoomLookup: hasPermission(user, 'sites.view') || hasPermission(user, 'report_admin.support'),
    // Legacy prop name used by tools whose mutation routes require settings.edit.
    isAdmin: hasPermission(user, 'settings.edit'),
    canEditContacts: hasPermission(user, 'contacts.edit'),
    canEditSites: hasPermission(user, 'sites.edit'),
    canEditSettings: hasPermission(user, 'settings.edit'),
    canViewServerAdmin: hasPermission(user, 'server_admin.view'),
    canOperateServerAdmin:
      hasPermission(user, 'server_admin.operate') && hasPermission(user, 'server_admin.view'),
    canViewValidation: hasPermission(user, 'validation.view'),
    canRunValidation: hasPermission(user, 'validation.run'),
    canManageValidation: hasPermission(user, 'validation.manage'),
  };
}
